var _title, _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGauge3(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 180,
    viewBox: "0 0 266 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Engagement Score Gauge at level 3 out of 5")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8456 22.4125C88.0065 23.0077 86.998 24.981 87.5932 26.8201C88.1883 28.6592 90.1616 29.6676 92.0007 29.0725C117.919 20.6853 145.835 20.7697 171.702 29.3133C173.538 29.9196 175.517 28.9231 176.123 27.0876C176.73 25.2521 175.733 23.2727 173.898 22.6665C146.618 13.6565 117.179 13.5675 89.8456 22.4125ZM179.766 28.2474C180.545 26.4779 182.61 25.6744 184.379 26.4525C210.677 38.0178 232.609 57.6572 246.995 82.524C247.963 84.1971 247.392 86.3382 245.719 87.3062C244.046 88.2742 241.904 87.7026 240.936 86.0294C227.294 62.4497 206.498 43.8269 181.561 32.8602C179.792 32.0821 178.988 30.0168 179.766 28.2474ZM247.41 90.2878C249.161 89.4678 251.244 90.2221 252.064 91.9725C264.252 117.988 267.838 147.208 262.303 175.399C261.931 177.296 260.091 178.531 258.195 178.159C256.298 177.787 255.062 175.947 255.434 174.05C260.683 147.319 257.282 119.611 245.726 94.9421C244.906 93.1916 245.66 91.1079 247.41 90.2878ZM17.5718 86.5741C15.9097 85.5871 15.3625 83.4396 16.3496 81.7776C31.0187 57.0764 53.1728 37.6883 79.6008 26.4235C81.379 25.6655 83.435 26.4926 84.1929 28.2708C84.9509 30.049 84.1238 32.105 82.3456 32.8629C57.2855 43.5447 36.2781 61.9292 22.3682 85.3519C21.3812 87.0139 19.2338 87.5611 17.5718 86.5741ZM4.51394 175.361C4.96076 177.242 6.84754 178.404 8.72819 177.957C10.6088 177.51 11.7712 175.624 11.3244 173.743C5.02739 147.239 7.33413 119.419 17.9102 94.3137C18.6607 92.5324 17.8249 90.4799 16.0436 89.7295C14.2622 88.979 12.2097 89.8147 11.4593 91.5961C0.305896 118.071 -2.12675 147.41 4.51394 175.361Z",
    fill: "url(#paint0_radial_590_35644)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_590_35644)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132.294,
    cy: 18.585,
    r: 10.5391,
    transform: "rotate(0.25 132.294 18.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.294,
    cy: 18.585,
    r: 10.5391,
    transform: "rotate(0.25 132.294 18.585)",
    stroke: "#D28295",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_590_35644",
    x: 96.2984,
    y: -4.2367,
    width: 71.9911,
    height: 71.9911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3913
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_590_35644"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_590_35644",
    result: "effect2_dropShadow_590_35644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_590_35644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_590_35644",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50001 179) scale(250.5 312.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA572"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge3);
export default __webpack_public_path__ + "assets/media/gauge-3.edea3d07.svg";
export { ForwardRef as ReactComponent };